import script from "./ContactsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactsComponent.vue?vue&type=script&setup=true&lang=js"

import "./ContactsComponent.vue?vue&type=style&index=0&id=63a9cc84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a9cc84"]])

export default __exports__